import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollAppToTop } from './ScrollAppToTop';
import { AppShellProvider } from './AppShellContext';
import { AppShellLayout } from './AppShellLayout';
/**
 * All-in-one frame that provides an app's overall layout and also loads configs
 * and provides an authentication layer.
 *
 * @constant
 */
export const AppShell = (_a) => {
    var { AppBar, children, supportEmailUrl } = _a, providerProps = __rest(_a, ["AppBar", "children", "supportEmailUrl"]);
    return (_jsxs(AppShellProvider, Object.assign({}, providerProps, { children: [_jsx(ScrollAppToTop, {}), _jsx(AppShellLayout, Object.assign({}, { AppBar, children, supportEmailUrl }))] })));
};
